/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCallLogEntryFromJSON, StreemApiCallLogEntryToJSON, } from './';
export function StreemApiGetUserCallLogEntryResponseFromJSON(json) {
    return StreemApiGetUserCallLogEntryResponseFromJSONTyped(json, false);
}
export function StreemApiGetUserCallLogEntryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'callLogEntry': !exists(json, 'call_log_entry') ? undefined : StreemApiCallLogEntryFromJSON(json['call_log_entry']),
    };
}
export function StreemApiGetUserCallLogEntryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'call_log_entry': StreemApiCallLogEntryToJSON(value.callLogEntry),
    };
}
//# sourceMappingURL=StreemApiGetUserCallLogEntryResponse.js.map